import api from '~/store/services/api';
import urlConstants from '~/lib/constants/url.constants';

type Report = {
  description: string;
  name: string;
  reportId: string;
};
export const reportsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPatientNoteSummaryDashboardReportLink: build.query<string, string>({
      query: (patientId: string) => ({
        url: urlConstants.reports.getPatientNoteSummaryDashboardReportLink(
          patientId,
        ),
        method: 'GET',
        responseHandler: 'text',
      }),
      keepUnusedDataFor: 0,
    }),
    getPatientInsightsDashboardReportLink: build.query<string, string>({
      query: (patientId: string) => ({
        url: urlConstants.reports.getPatientInsightsDashboardReportLink(
          patientId,
        ),
        method: 'GET',
        responseHandler: 'text',
      }),
      keepUnusedDataFor: 0,
    }),
    getPatientReportLink: build.query<string, string>({
      query: (patientId: string) => ({
        url: urlConstants.reports.getPatientReportLink(patientId),
        method: 'GET',
        responseHandler: 'text',
      }),
    }),
    getUserReportLink: build.query<string, string>({
      query: (reportId: string) => ({
        url: urlConstants.reports.getUserReportLink(reportId),
        method: 'GET',
        responseHandler: 'text',
      }),
    }),
    getUserReports: build.query<Report[], void>({
      query: () => ({
        url: urlConstants.reports.getUserReports,
      }),
    }),
  }),
});

export const {
  useGetPatientNoteSummaryDashboardReportLinkQuery,
  useGetPatientInsightsDashboardReportLinkQuery,
  useGetUserReportsQuery,
  useLazyGetPatientReportLinkQuery,
  useLazyGetUserReportLinkQuery,
} = reportsApi;
